import { twMerge } from "tailwind-merge"

type Props = {
  positionStyle?: React.CSSProperties
  className?: string
}

const HorizontalDottedLine = ({ positionStyle, className }: Props) => {
  return (
    <div
      className={twMerge(
        "hidden pointer-events-none lg:block border-t border-dashed border-neutral-300 dark:border-neutral-800",
        className
      )}
      style={{
        height: "1px",
        zIndex: -1,
        position: "relative",
        ...positionStyle,
      }}
    >
      <div
        className="bg-linear-to-r from-bg-default via-bg-default/0 to-bg-default"
        style={{
          position: "absolute",
          left: 0,
          top: "-1px",
          right: 0,
          bottom: 0,
          height: "2px",
        }}
      />
    </div>
  )
}

export default HorizontalDottedLine
